import { OpenPosition } from "../../types/general";

const openPositions: OpenPosition[] = [];

export default openPositions;